import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { ClientFocus } from 'src/shared/features/users/schemas/client-focus'
import type { Expertise } from 'src/shared/features/users/schemas/expertise'
import type { Language } from 'src/shared/features/users/schemas/language'
import type { Profession } from 'src/shared/features/users/schemas/profession'

type MatchedParams = {
  profession: Profession
  state: string
  longitude: number
  latitude: number
  client_focus?: ClientFocus
  languages?: Language[]
  expertise?: Expertise[]
}

export const users = createQueryKeys('users', {
  me: {
    queryKey: null,
    contextQueries: {
      tokens: null,
      licenses: null,
      preferences: null,
      privacyPreferences: (userId: number) => [userId],
      tutorials: null,
    },
  },
  detailById: (userId: number) => ({
    queryKey: [userId],
    contextQueries: {
      photos: (photoType: string) => [photoType],
      licenses: null,
    },
  }),
  detailByUsername: (username: string) => [username],
  search: (
    query?: string,
    profession?: string,
    longitude?: number,
    latitude?: number,
    distance?: number,
    expertise?: string[],
    clientType?: string,
  ) => [query, profession, longitude, latitude, distance, expertise, clientType],
  publicSearch: (
    query?: string,
    profession?: string,
    longitude?: number,
    latitude?: number,
    expertise?: string[],
    clientFocus?: string,
    city?: string,
    state?: string,
  ) => [query, profession, longitude, latitude, expertise, clientFocus, city, state],
  matched: (params: MatchedParams) => [{ params }],
  mostActive: null,
  licenses: (params: { status: string; searchQuery?: string }) => [{ params }],
  transactions: (userId: number, filter?: string) => [userId, filter],
  reviews: (userId: number) => [userId],
})

export const portfolio = createQueryKeys('portfolio', {
  all: (userId: number) => [userId],
  byId: (itemId: number) => [itemId],
})
